import React, { useEffect, useState } from "react";
import './FaultFirstPageCustom.css';
import { ThreeCircles } from 'react-loader-spinner';
import useHttp from "../../../../hook/use-http";
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
import value from "wink-statistics/src/accessor";

const TOP_KPIS_FIRST_PAGE = {
  totalvehiclecount: 0,
  fault_active_duration: 0,
  vehicle_with_fault: 0,
  vehicle_with_alarm: 0,
  vehicle_with_dtc: 0,
};

export default function FaultFirstPageKpis({ gloablfilter }) {
  const [topdata, setTopData] = useState(TOP_KPIS_FIRST_PAGE);
  const [faultactive, setFaultActive] = useState(TOP_KPIS_FIRST_PAGE);
  const [vehiclewithfaults, setVehicleWithFaults] = useState(TOP_KPIS_FIRST_PAGE);
  const [vehiclewithalarm, setVehicleWithAlarm] = useState(TOP_KPIS_FIRST_PAGE);
  const [vehiclewithdtc, setVehicleWithDtc] = useState(TOP_KPIS_FIRST_PAGE);
  const [timeDuration, setTimeDuration] = useState(0);

  const { isLoading, error, sendReq: fetchData } = useHttp();
  const appyData = (data) => {
    const res_result = data;

    let responce = {};
    if (res_result.length != 0) {
      let temp_result = res_result;
      responce = {
        totalvehiclecount: temp_result.vehicleId.value
      }
      setTopData((prestate) => responce);
    }
  }
  function toTime(minute) {
    if (minute === undefined || minute === 0) {
      return 0
    } else {
      let minutes = Math.floor(minute / vehiclewithfaults.vehicle_with_fault)
      var h = Math.floor(minutes / 60);
      var m = minutes % 60;
      h = h < 10 ? '0' + h : h;
      m = m < 10 ? '0' + m : m;
      return `${h}h ${m}min`
    }
  }
  const faultActive = (data) => {
    const res_result = data;

    let responce = {};
    if (res_result.length != 0) {
      let temp_result = res_result;
      responce = {
        fault_active_duration: temp_result.TotalTime.value
      }
      setFaultActive((prestate) => responce);
    }

  }
  const vehicleWithFaults = (data) => {
    const res_result = data;
    let responce = {};
    if (res_result.length != 0) {
      let temp_result = res_result;
      responce = {
        vehicle_with_fault: temp_result.vehicleId.value
      }
      setVehicleWithFaults((prestate) => responce);
    }
  }

  const vehicleWithAlarm = (data) => {
    const res_result = data;
    let responce = {};
    if (res_result.length != 0) {
      let temp_result = res_result;
      responce = {
        vehicle_with_alarm: temp_result.vehicleId.value
      }
      setVehicleWithAlarm((prestate) => responce);
    }
  }

  const vehicleWithDtc = (data) => {
    const res_result = data;
    let responce = {};
    if (res_result.length != 0) {
      let temp_result = res_result;
      responce = {
        vehicle_with_dtc: temp_result.vehicleId.value
      }
      setVehicleWithDtc((prestate) => responce);
    }
  }

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "faultfirstpage/topkpisfirstpage", body: { filterdata: gloablfilter } }, appyData)
    fetchData({ url: API_URL_MAIN + "faultfirstpage/faultalertduration", body: { filterdata: gloablfilter } }, faultActive)
    fetchData({ url: API_URL_MAIN + "faultfirstpage/faultalertoccdur", body: { filterdata: gloablfilter } }, vehicleWithFaults)
    fetchData({ url: API_URL_MAIN + "faultfirstpage/faultalarm", body: { filterdata: gloablfilter } }, vehicleWithAlarm)
    fetchData({ url: API_URL_MAIN + "faultfirstpage/faulwithdtc", body: { filterdata: gloablfilter } }, vehicleWithDtc)
  }, [gloablfilter])

  let loader = (<div style={{ margin: "auto" }}><ThreeCircles
    height="50"
    width="40"
    wrapperStyle={{}}
    wrapperClass=""
    visible={true}
    ariaLabel="three-circles-rotating"
    outerCircleColor="#3498db"
    innerCircleColor="#dec52d"
    middleCircleColor="#db213a"
  /></div>)
  return (
    <>
      <section className="kpi my-3">
        <div className="row">
          <div className="col-md-12 col-sm-12 col-12 col-lg-7 pl-4">
            <div className="row">
              <div className="col-md-6 col-sm-12 col-lg-4 pl-0 evtpks-pl0">
                <div className="widget p-2 py-4 d-flex align-items-center">
                  {isLoading ? loader : (<> <div className="widgetIcon"><img src={"/assets/img/EV-Logo-1.png"} /> </div>
                    <div className="ps-3">
                      <p className="h5 m-0">{topdata.totalvehiclecount}</p>
                      <p className="m-0"><small className="text-mutedf">Total Vehicle Count</small></p>
                    </div></>)}
                </div>
              </div>
              <div className="col-md-6 col-sm-12 col-lg-4 pl-0 evtpks-pl0">
                <div className="widget p-2 py-4 d-flex align-items-center">
                  {isLoading ? loader : (<> <div className="widgetIcon"><img src={"/assets/img/notification_important_black_24dp 1.png"} /> </div>
                    <div className="ps-3">
                      <p className="h5 m-0">{toTime(faultactive.fault_active_duration)}</p>
                      <p className="m-0"><small className="text-mutedf">Fault Duration/Vehicle</small></p>
                    </div></>)}
                </div>
              </div>
              <div className="col-md-6 col-sm-12 col-lg-4 pl-0 evtpks-pl0">
                <div className="widget p-2 py-4 d-flex align-items-center">
                  {isLoading ? loader : (<> <div className="widgetIcon"><img src={"/assets/img/taxi_alert_black_24dp 1.png"} /> </div>
                    <div className="ps-3">
                      <p className="h5 m-0">{vehiclewithfaults.vehicle_with_fault}</p>
                      <p className="m-0"><small className="text-mutedf">Vehicles With Fault</small></p>
                    </div></>)}
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12 col-sm-12 col-12 col-lg-5 pl-4 evtpks-pl0">
            <div className="row">
              <div className="col-md-6 col-sm-12 pl-0">
                <div className="widget p-2 py-4 d-flex align-items-center">
                  {isLoading ? loader : (<> <div className="widgetIcon"><img src={"/assets/img/alarm_on_black_24dp 2.png"} /> </div>
                    <div className="ps-3">
                      <p className="h5 m-0">{vehiclewithalarm.vehicle_with_alarm}</p>
                      <p className="m-0"><small className="text-mutedf">Vehicles With Alarm</small></p>
                    </div></>)}
                </div>
              </div>
              <div className="col-md-6 col-sm-12 pl-0 evtpks-pl0">
                <div className="widget p-2 py-4 d-flex align-items-center">
                  {isLoading ? loader : (<> <div className="widgetIcon"><img src={"/assets/img/car_repair_black_24dp 2.png"} /> </div>
                    <div className="ps-3">
                      <p className="h5 m-0">{vehiclewithdtc.vehicle_with_dtc}</p>
                      <p className="m-0"><small className="text-mutedf">Vehicles With DTC</small></p>
                    </div></>)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
